import { render, staticRenderFns } from "./ImportBrandDiscount.vue?vue&type=template&id=2fc53be3&scoped=true&"
import script from "./ImportBrandDiscount.vue?vue&type=script&lang=js&"
export * from "./ImportBrandDiscount.vue?vue&type=script&lang=js&"
import style0 from "./ImportBrandDiscount.vue?vue&type=style&index=0&id=2fc53be3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc53be3",
  null
  
)

export default component.exports